import { FaUserLock, FaUnlock } from 'react-icons/fa6'
import { FaRegEdit } from 'react-icons/fa'
import { OverlayTrigger, Popover } from "react-bootstrap";
import useCommonFunctions from '../../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions';

const User = ({ user, index, onEdit, onResetPassword, onLockUnlock }) => {
    const { getInfoCheckbox } = useCommonFunctions()

    const popover = (text) => <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>{text}</span>
        </Popover.Body>
    </Popover>

    return (
        user &&
        <tr className='hoverable-row'>
            <td style={{ textAlign: 'center' }}>
                {index + 1}
            </td>
            <td>
                {user.firstName + " " + user.lastName}
            </td>
            <td>
                {user.userLogin}
            </td>
            <td>
                {user.phoneNumber}
            </td>
            <td style={{ textAlign: 'center' }}>
                {getInfoCheckbox(user.roles.some(item => item.roleName.toUpperCase() === 'ADMINISTRATOR'))}
            </td>
            <td style={{ textAlign: 'center' }}>
                {getInfoCheckbox(user.roles.some(item => item.roleName.toUpperCase() === 'ZAMÓWIENIA'))}
            </td>
            <td style={{ textAlign: 'center' }}>
                {getInfoCheckbox(user.roles.some(item => item.roleName.toUpperCase() === 'OFERTY'))}
            </td>
            <td style={{ textAlign: 'center' }}>
                {getInfoCheckbox(user.roles.some(item => item.roleName.toUpperCase() === 'FINANSE'))}
            </td>
            <td style={{ textAlign: 'center' }}>
                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Wyślij link do resetu hasła')}>
                    <button onClick={() => onResetPassword(user)} style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                        <img
                            src={'/Icons/password-reset.png'}
                            alt='password-reset'
                            color='black'
                            style={{ maxWidth: '20px', maxHeight: '20px', objectFit: 'contain' }}
                        />
                    </button>
                </OverlayTrigger>
            </td>

            <td style={{ textAlign: 'center' }}>
                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover('Edytuj')}>
                    <button onClick={() => onEdit(user)} style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                        <FaRegEdit color='black' />
                    </button>
                </OverlayTrigger>
            </td>
            <td style={{ textAlign: 'center' }}>
                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover(user.isActive ? 'Zablokuj użytkownika' : 'Odblokuj użytkownika')}>
                    <button onClick={() => onLockUnlock(user)} style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                        {user.isActive == 1 ? <FaUserLock color='black' /> : <FaUnlock className='primary-accent-color-text' />}
                    </button>
                </OverlayTrigger>
            </td>
        </tr>
    )
}

export default User
